<div class="container">
  <div class="row content">
    <div class="col-lg">
      <ul class="list list-unstyled">
        <li class="title" i18n="@@front.footer.products">Products</li>
        <li>
          <a routerLink="/page/lite" i18n="@@front.footer.core">Lite</a>
        </li>
        <li>
          <a routerLink="/page/pro" i18n="@@front.footer.pre">Pro</a>
        </li>
        <li>
          <a routerLink="/page/vip" i18n="@@front.footer.vip">VIP</a>
        </li>
        <li>
          <a routerLink="/otc" i18n="@@front.footer.otc">OTC</a>
        </li>
        <li>
          <a
            [href]="links.apiDocs"
            target="_blank"
            rel="noopener"
            i18n="@@front.footer.api"
            >API</a
          >
        </li>
        <!-- <li>
          <a routerLink="/invite-and-earn" i18n="@@front.footer.affiliate">Affiliate Program</a>
        </li> -->
      </ul>
    </div>
    <!-- .col-lg -->
    <div class="col-lg">
      <ul class="list list-unstyled">
        <li class="title" i18n="@@front.footer.prices">Prices</li>
        <li>
          <a routerLink="/prices" i18n="@@front.footer.allPrices">All</a>
        </li>
        <li>
          <a
            routerLink="/prices/BTC-{{ this.fiatCurrency }}"
            i18n="@@front.footer.bitcoin"
            >Bitcoin</a
          >
        </li>
        <li>
          <a
            routerLink="/prices/ETH-{{ this.fiatCurrency }}"
            i18n="@@front.footer.ether"
            >Ether</a
          >
        </li>
        <li>
          <a
            routerLink="/prices/XRP-{{ this.fiatCurrency }}"
            i18n="@@front.footer.xrp"
            >XRP</a
          >
        </li>
      </ul>
    </div>
    <!-- .col-lg -->
    <div class="col-lg">
      <ul class="list list-unstyled">
        <li class="title" i18n="@@front.footer.company">Company</li>
        <li>
          <a routerLink="/about-us" i18n="@@front.footer.aboutUs">About us</a>
        </li>
        <li>
          <a
            routerLink="/careers"
            target="_blank"
            rel="noopener"
            i18n="@@front.footer.careers"
            >Careers</a
          >
        </li>
        <li>
          <a
            routerLink="/page/terms-of-service"
            i18n="@@front.footer.termsofService"
            >Terms of service</a
          >
        </li>
        <li>
          <a
            routerLink="/page/legal-and-compliance"
            i18n="@@front.footer.legal.compliance"
            >Legal & Compliance</a
          >
        </li>
        <li>
          <a routerLink="/page/security" i18n="@@front.footer.security"
            >Security</a
          >
        </li>
        <li>
          <a
            [href]="links.bugBounty"
            target="_blank"
            i18n="@@front.footer.bugBounty"
            >Responsible Disclosure</a
          >
        </li>
      </ul>
    </div>
    <!-- .col-lg -->
    <div class="col-lg">
      <ul class="list list-unstyled">
        <li class="title" i18n="@@front.footer.learn">Learn</li>
        <li>
          <a routerLink="/page/faq" i18n="@@front.footer.faq">FAQ</a>
        </li>
        <li>
          <a
            [href]="links.blog"
            target="_blank"
            rel="noopener"
            i18n="@@front.footer.blog"
            >Blog</a
          >
        </li>
        <li>
          <a
            [href]="isAr ? links.support.ar : links.support.en"
            target="_blank"
            rel="noopener"
            i18n="@@front.footer.support"
            >Support</a
          >
        </li>
 

        <li>
          <a routerLink="/page/fees" i18n="@@front.footer.fees">Fees</a>
        </li>
        <li>
          <a routerLink="/page/supported-tokens" i18n="@@front.footer.pairs"
            >Supported Tokens</a
          >
        </li>
      </ul>
    </div>
    <!-- .col-lg -->
    <div class="col-lg">
      <ul class="list list-unstyled">
        <li class="title" i18n="@@front.footer.socialMedia">Social Media</li>
        <li>
          <div class="social row align-items-start">
            <a
              href="https://www.facebook.com/bitoasis/"
              target="_blank"
              class="col-auto facebook"
              rel="noopener"
            >
              <img
                src="assets/images/social/facebook.svg"
                alt="Facebook"
                i18n-alt="@@socialMedia.facebook"
              />
            </a>
            <a
              href="https://twitter.com/bitoasis"
              target="_blank"
              class="col-auto twitter"
              rel="noopener"
            >
              <img
                src="assets/images/social/x.svg"
                alt="Twitter"
                i18n-alt="@@socialMedia.twitter"
              />
            </a>
            <a
              href="https://t.me/BitOasisOfficial"
              target="_blank"
              class="col-auto telegram"
              rel="noopener"
            >
              <img
                src="assets/images/social/telegram.svg"
                alt="Telegram"
                i18n-alt="@@socialMedia.telegram"
              />
            </a>
            <a
              href="https://www.instagram.com/bitoasismena/"
              target="_blank"
              class="col-auto instagram"
              rel="noopener"
            >
              <img
                src="assets/images/social/instagram.svg"
                alt="Instagram"
                i18n-alt="@@socialMedia.instagram"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/bitoasis-technologies-fze/"
              target="_blank"
              class="col-auto linked"
              rel="noopener"
            >
              <img
                src="assets/images/social/linkedin.svg"
                alt="Linkedin"
                i18n-alt="@@socialMedia.linkedin"
              />
            </a>
            <a
              href="https://www.youtube.com/channel/UCUDe9ACYq5apHbeXGKufyog"
              target="_blank"
              class="col-auto linked"
              rel="noopener"
            >
              <img
                src="assets/images/social/youtube.svg"
                alt="YouTube"
                i18n-alt="@@socialMedia.youtube"
              />
            </a>
            <a
              href="https://www.tiktok.com/@bitoasis"
              target="_blank"
              class="col-auto linked"
              rel="noopener"
            >
              <img
                src="assets/images/social/tiktok.svg"
                alt="TikTok"
                i18n-alt="@@socialMedia.tiktok"
              />
            </a>
          </div>
        </li>
        <li class="p-2"></li>
        <li class="title mb-1" i18n="@@front.footer.apps">Apps</li>
        <li>
          <div class="app-store d-flex align-items-start justify-content-start">
            <a
              (click)="onAppDownloadClick(GeneralEvents.HomeAppleStoreCta)"
              href="https://apple.co/31XHi3T"
              target="_blank"
              rel="noopener"
            >
              <img
                alt="Download on the App Store"
                i18n-alt="@@appStore.appStore"
                src="assets/images/mobile-stores/{{
                  currentLanguage
                }}/apple-app-store.svg"
              />
            </a>
            <div class="spacer"></div>
            <a
              (click)="onAppDownloadClick(GeneralEvents.HomeGooglePlayCta)"
              href="https://play.google.com/store/apps/details?id=com.bitoasis&hl={{
                currentLanguage
              }}"
              target="_blank"
              rel="noopener"
            >
              <img
                alt="Get it on Google Play"
                i18n-alt="@@appStore.playStore"
                src="assets/images/mobile-stores/{{
                  currentLanguage
                }}/google-play-store.svg"
              />
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!-- .row -->
  <div *ngIf="displayDisclaimer" class="disclaimer-content">
    <p i18n="@@disclaimer.highRisk">
      High Risk Investment Warning: Trading in Virtual Assets carries a high
      degree of risk due to their volatility and it is possible to lose all your
      capital. These products may not be suitable for everyone and you should
      ensure that you understand the risks involved. Seek independent expert
      advice if necessary and trade only with funds you can afford to lose. We
      do not recommend users to trade using borrowed funds or loans. For more
      information, please refer to BitOasis's
      <a routerLink="/page/risk-disclosure">Risk Disclosure</a>.
    </p>

    <p i18n="@@disclaimer.content">
      Disclaimer: The content of this page is for information purposes only and
      it is not intended as a recommendation, guidance or professional advice.
      Any indication of past performance or simulated past performance included
      in advertisements published by BitOasis is not a reliable indicator of
      future results. BitOasis does not offer recommendation, guidance, or
      professional advice on holding or disposing of Virtual Assets and operates
      on an execution-only basis. The user carries the sole responsibility for
      all the businesses or investments that are carried out at BitOasis.
    </p>

    <p i18n="@@disclaimer.legalInfo">
      Legal Information: With any investment, your capital is at risk. The value
      of your account with BitOasis can go down as well as up and you may get
      back less than you invest. Past performance is no guarantee of future
      results.
    </p>

    <p i18n="@@disclaimer.termsOfService">
      Read our Terms of Service for more information. By using this website, you
      accept our Terms of Service and Privacy Policy. Copyright 2020.
    </p>

    <p i18n="@@disclaimer.companyInfo">
      BitOasis Technologies FZE is a company formed and existing in the United
      Arab Emirates under the Dubai Integrated Economic Zones Authority (License
      number 1462). BitOasis operates under its MVP Operational License issued
      by the Dubai Virtual Assets Regulatory Authority (“VARA”) for the
      provision of Broker-Dealer Services.
    </p>
  </div>

  <div class="border"></div>

  <div class="footer-content">
    <div class="logo">
      <img src="assets/images/logo-white.svg" alt="" />
    </div>
    <div class="p-3"></div>
    <div class="text" i18n="@@front.footer.copyright">
      Copyright © {{ year }} BitOasis Company. All rights reserved.
    </div>
  </div>

  <div class="vara-disclaimer" i18n="@@front.footer.vara.disclaimer">
    BitOasis Technologies FZE licensed by the Dubai Virtual Assets Regulatory
    Authority (VARA) as a Virtual Asset Service Provider (VASP Reference:
    VL/2024/11/001) for the following Virtual Asset Activity: (i) Broker-Dealer
    Services
  </div>
</div>
<!-- .container -->
